import { TaxBill, TaxBillRecord } from '../models';
import { Nullable } from 'common';

export interface TaxTraxTaxBillRecordState {
  taxBillRecord: Nullable<TaxBillRecord>;
  taxBill: Nullable<TaxBill>;
  loading: boolean;
}

export const TAXTRAX_TAX_POLICY_INFO_SET_LOADING =
  'TAXTRAX_TAX_POLICY_INFO_SET_LOADING';
export const TAXTRAX_TAX_POLICY_INFO_RESULT_SUCCESS =
  'TAXTRAX_TAX_POLICY_INFO_RESULT_SUCCESS';
export const TAXTRAX_TAX_RESET_RESULTS = 'TAXTRAX_TAX_RESET_RESULTS';

export const TAXTRAX_TAX_BILL_RECORD_ADD = 'TAXTRAX_TAX_BILL_RECORD_ADD';
export const TAXTRAX_TAX_BILL_RECORD_CLEAR = 'TAXTRAX_TAX_BILL_RECORD_CLEAR';
export const TAXTRAX_TAX_BILL_RECORD_LOADING =
  'TAXTRAX_TAX_BILL_RECORD_LOADING';

export interface PolicyTaxInfoState {
  loading: boolean;
}

export interface SetTaxResultLoadingType {
  type: typeof TAXTRAX_TAX_POLICY_INFO_SET_LOADING;
  loading: boolean;
}

export interface ResetTaxResultsType {
  type: typeof TAXTRAX_TAX_RESET_RESULTS;
}

interface TaxTraxTaxBillRecordAddAction {
  type: typeof TAXTRAX_TAX_BILL_RECORD_ADD;
  payload: { taxBill: TaxBill; taxBillRecord: TaxBillRecord };
}

interface TaxTraxTaxBillRecordClearAction {
  type: typeof TAXTRAX_TAX_BILL_RECORD_CLEAR;
}

interface TaxTraxTaxBillRecordLoadingAction {
  type: typeof TAXTRAX_TAX_BILL_RECORD_LOADING;
  payload: boolean;
}

export type TaxTraxTaxDetailsActionTypes =
  | TaxTraxTaxBillRecordAddAction
  | TaxTraxTaxBillRecordClearAction
  | TaxTraxTaxBillRecordLoadingAction;
